import { useCallback, useState } from 'react';
import type { SimpleSearchQuery } from '@/shared/ui/search/SimpleSearch';
import type { SearchQuery } from '@/shared/ui/search/AdvancedSearch';
import {
  convertSearchQueryToOrderQuery,
  convertSimpleToOrderQuery,
} from '@/widgets/order/order-list-table/model';

interface UseOrderSearchQueryOptions {
  initialQuery?: SimpleSearchQuery | SearchQuery;
  isSimple?: boolean;
}

export function useOrderSearchQuery({ initialQuery, isSimple }: UseOrderSearchQueryOptions) {
  const [currentQuery, setCurrentQuery] = useState<SimpleSearchQuery | SearchQuery | null>(
    initialQuery || null
  );

  const toOrderQuery = useCallback(
    (searchQuery: SimpleSearchQuery | SearchQuery, cursor?: string) => {
      return isSimple
        ? convertSimpleToOrderQuery(searchQuery as SimpleSearchQuery, cursor)
        : convertSearchQueryToOrderQuery(searchQuery as SearchQuery, cursor);
    },
    [isSimple]
  );
  return { currentQuery, setCurrentQuery, toOrderQuery };
}
